
<template>
    <div class="outerHomepage">
        <div class="HomeTopImage">

            <!-- Desktop video background -->
            <video
                autoplay
                muted
                loop
                playsinline
                class="HomeTopVideo"
            >
                <source
                    src="https://wp-ocssport.ocs-sport.com/videos/IMG_7537.MOV"
                    type="video/mp4"
                >
            </video>

            <div class="homepage">
                <b-row class="container bannersec">
                    <!-- Optional banner content -->
                </b-row>

                <div class="HomeMain-Text">
                    <h2 class="HomeTitle">
                        Ready to feel the thrill of racing
                    </h2>

                    <template v-if="isMobile()">
                        <h3 class="HomeSubTitle">
                            Come check out our high-tech racing simulator
                            studio in Maresfield, Uckfield<br>
                            Whether you're totally new or a racing pro,
                            there's a seat with your name on it.<br>
                            Just pick your car, choose your track, and
                            hit the gas in 30-minute sessions<br>
                            packed with fun.
                        </h3>
                    </template>

                    <template v-else>
                        <h3 class="HomeSubTitle">
                            Come check out our high-tech racing simulator
                            studio in Maresfield, Uckfield<br>
                            Whether you're totally new or a racing pro,
                            there's a seat with your name on it.<br>
                            Just pick your car, choose your track, and
                            hit the pedal in 30-minute sessions<br>
                            packed with fun.
                        </h3>
                    </template>

                    <b-link :to="'/contact'">
                        <b-button class="HomepageBtn">
                            Get in Touch Today
                        </b-button>
                    </b-link>

                    <div class="homePageArrow">
                        <img
                            class="arrowHomepage pulse"
                            @click="scrollNextSection()"
                            src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/06/White-page-down-arrow.png"
                            alt="Scroll down"
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'HomeTopImage',

    components: {},

    data: function() {
        return {
            acf: [],
        }
    },

    methods: {
        isMobile() {
            return window.innerWidth <= 768
        },

        scrollNextSection() {
            var score = document.getElementById("about")

            if (score) {
                score.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                })
            }
        },
    },

    mounted() {
        axios
            .get(
                process.env.VUE_APP_API_URL +
                'racepark' +
                "/wp-json/wp/v2/pages/4" +
                '?randomadd=' +
                new Date().getTime()
            )
            .then((response) => {
                this.acf = response.data
            })
    },
}
</script>

<style scoped>
.HomeTopImage {
    position: relative;
    height: 1080px;
    max-height: 1080px;
    background-image: url('https://wp-ocssport.ocs-sport.com/wp-content/themes/wp-bootstrap-starter/images/race_homepage_header1.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
}

/* Dark overlay over the video or image */
.HomeTopImage::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    pointer-events: none;
}

/* Desktop video background */
.HomeTopVideo {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transform: translate(-50%, -50%);
    z-index: 0;
}

/* Keep homepage content above the overlay */
.HomeTopImage > .homepage {
    position: relative;
    z-index: 2;
}

.bannersec {
    margin: auto;
    display: block;
    padding-top: 100px;
}

img.banner {
    width: 100%;
}

h3.HomeSubTitle {
    color: #D80E1F;
    font-family: "noto-sans", sans-serif;
    font-weight: 700;
    font-style: normal;
}

span.trackManText {
    color: #fff;
    font-weight: bold;
}

.HomeMain-Text {
    padding-top: 150px;
    z-index: 999;
    position: relative;
}

.HomeTitle {
    color: #fff;
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
    font-size: 80px;
    padding-bottom: 60px;
}

button.HomepageBtn {
    background-color: #D80E1F;
    border-color: #D80E1F !important;
    border-radius: 50px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 252px;
    height: 54px;
    margin-top: 65px;
    font-family: "noto-sans", sans-serif;
}

button.HomepageBtn:hover {
    background-color: #707070;
    border-color: #707070 !important;
    color: #fff;
}

.arrowHomepage {
    height: 40px;
    width: 70px;
    cursor: pointer;
}

.homePageArrow {
    margin-top: 100px;
}

.pulse {
    animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}

.btn-circle {
    width: 90px;
    height: 90px;
    border-radius: 60px;
    font-size: 40px;
    color: rgba(255, 255, 255, 0.6);
    transition: background .4s ease-in-out;
}

.btn-circle:hover,
.btn-circle:focus {
    outline: 0;
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
}

/* Mobile: use the original image instead of the video */
@media only screen and (max-width: 768px) {
    .HomeTopImage {
        height: 870px;
        max-height: 870px;
        background-image: url('https://wp-ocssport.ocs-sport.com/wp-content/themes/wp-bootstrap-starter/images/race_homepage_header1.png');
        background-position: center;
        background-size: cover;
    }

    .HomeTopVideo {
        display: none;
    }

    .bannersec {
        margin: auto;
        display: block;
        padding-top: 50px;
        padding-bottom: 25px;
    }

    .HomeTitle {
        color: #fff;
        font-weight: 700;
        font-style: italic;
        font-size: 42px;
        padding-bottom: 24px;
        padding-left: 30px;
        padding-right: 30px;
    }

    h3,
    .h3 {
        font-size: 18px;
        padding-left: 32px;
        padding-right: 32px;
    }

    h3.HomeSubTitle {
        line-height: 1.5;
    }

    .HomeMain-Text {
        padding-top: 30px;
    }

    button.HomepageBtn {
        margin-top: 47px;
    }

    .homePageArrow {
        margin-top: 65px;
    }
}

@media only screen and (max-width: 375px) {
    .HomeTitle {
        color: #fff;
        font-weight: bold;
        font-style: italic;
        font-size: 40px;
        padding-bottom: 60px;
    }

    h3,
    .h3 {
        font-size: 20px;
        padding-left: 32px;
        padding-right: 32px;
    }

    .HomeMain-Text {
        padding-top: 40px !important;
    }
}
</style>
